const statuses = [
    {
        id: "todo",
        name: "To Do",
    },
    {
        id: "in_progress",
        name: "In Progress",
    },
    {
        id: "idle",
        name: "Idle",
    },
    {
        id: "done",
        name: "Done",
    },
];

export default statuses;
